import { ChangeDetectionStrategy, Component } from '@angular/core';
import { buildMlpCampaignUrl } from './mlp-campaign-url.helper';

const MLP_KFZ_SERVICE_CAMPAIGN_ID = 'c202518KFZSF';

/**
 * KFZ-2548: taking over an SF-Rabatt from a third person is not supported together with a
 * Versicherungswechsel. Shown on step 10 until MLP-63 lands, pointing the customer at the
 * MLP Kfz-Service callback booking.
 */
@Component({
  selector: 'app-mlp-rabatt-uebertragung-message',
  template: `
    <div
      data-testid="rabatt-uebertragung-message"
      class="flex flex-col gap-2 rounded-lg border border-cp-primary-100 px-6 py-4 text-base leading-6 text-cp-primary-100"
    >
      <p class="m-0">
        Um im Rahmen eines Versichererwechsels einen Rabatt von einer anderen dritten Person zu
        übernehmen, vereinbare bitte einen Rückruf mit unserem
        <a
          [href]="kfzServiceUrl"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="kfz-service-link"
          class="font-bold underline"
          (click)="openKfzService($event)"
          >MLP Kfz-Service</a
        >.
      </p>
      <p class="m-0">
        Über diesen Rechner lässt sich aktuell nur ein klassischer Versichererwechsel ohne
        Rabattübertragung berechnen. Um jetzt Ergebnisse für dich rechnen zu können, gib bitte deine
        eigenen SF-Klassen und die Daten zu deiner Vorversicherung an – nicht die des Rabattgebers.
      </p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MlpRabattUebertragungMessageComponent {
  protected get kfzServiceUrl(): string {
    return buildMlpCampaignUrl(MLP_KFZ_SERVICE_CAMPAIGN_ID);
  }

  // The checksum is the current date and the campaign rejects a stale one. Nothing marks this
  // OnPush component dirty after it renders, so the href can be days old by the time it is
  // clicked — rebuild it on the way out.
  protected openKfzService(event: MouseEvent): void {
    event.preventDefault();
    window.open(this.kfzServiceUrl, '_blank', 'noopener');
  }
}
